import AbstractNode from './AbstractNode';

export default class AccordionTitle extends AbstractNode {
    get name() {
        return "accordion_title";
    }

    get schema() {
        return {
            attrs: {
              active: {default: true}
            },
            content: "paragraph|heading",
            parseDOM: [{
                tag: 'div.ui.accordion > .title'
            }],
            selectable: true,
            draggable: false,
            isolating: true,
            toDOM: node => {
              if (node.attrs.active === true) {
                return ['div', {class: 'title active'}, 0];
              } else {
                return ['div', {class: 'title'}, 0];
              }
            }
        }
    }

    toMarkdown(state, node) {
        if (node.attrs.active === true) {
          state.write('<div class="title active">');
        } else {
          state.write('<div class="title">');
        }
        state.write('\n\n');
        state.renderContent(node);
        state.write('</div>');
        state.ensureNewLine();
    }

    get parseMarkdown() {
        return {
            block: 'accordion_title', getAttrs: token => ({
                active: token.attrGet('active') === true,
            }),
        }
    }
}